import React from 'react';
import { Gallery, Breakpoints, GallerySlide, styled } from '@volkswagen-onehub/components-core';
import { ClubCard } from './clubCard';

const StyledGallery = styled.div`
	& > section > div > div {
		gap: 0;
	}
`;

export const ClubGallery: React.FC<{}> = () => {
	const ClubCards = [
		{
			title: '**Si eres del club, te lo ponemos aún más fácil**',
			text: 'Beneficios únicos',
			image: 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/club-vw_easy.jpg',
			description: ['Tu guantera digital', 'Sesión con un experto', 'Atención prioritaria'],
		},
		{
			title: '**Nuestra obsesión: cuidar de ti y de tu coche**',
			text: 'Servicios exclusivos',
			image: 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/club-vw_care.jpg',
			description: ['Facilidades en taller', 'Asistencia en carretera gratuita', 'Despreocúpate de la ITV'],
		},
		{
			title: '**Vive Volkswagen al máximo**',
			text: 'Experiencias inolvidables',
			image: 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/club-vw_max.jpg',
			description: ['Experiencias de conducción', 'Accesorios Volkswagen', 'Lista VIP'],
		},
	];

	return (
		<StyledGallery className="styled-gallery">
			<Gallery
				id="club-gallery"
				aria-label="Club gallery"
				slidesPerPage={{
					[Breakpoints.default]: 1.25,
					[Breakpoints.b560]: 1.3,
					[Breakpoints.b960]: 2.1,
					[Breakpoints.b1280]: 2.85,
				}}
			>
				{ClubCards.map((element: any, index: number) => (
					<GallerySlide key={index} aria-labelledby={`slide${index}-heading`}>
						<ClubCard cardDetail={element} index={index} numberOfCards={ClubCards.length} />
					</GallerySlide>
				))}
			</Gallery>
		</StyledGallery>
	);
};
